module.exports = __webpack_public_path__ + "img/m_logo_title.f3d306d3.png";